/* Die finder + product-page fit check.
 * Machine list: <script id="die-machines"> from snippets/die-machines.liquid.
 * Remembered machine: localStorage 'em_machine' = {id, make, model, values, note}. */
(function () {
  'use strict';

  var STORAGE_KEY = 'em_machine';
  var FILTER_PARAM = 'filter.p.m.filters.model';
  var DEFAULT_COLLECTION = '/collections/pasta-dies';

  function getMachines() {
    var el = document.getElementById('die-machines');
    if (!el) return [];
    try {
      var list = JSON.parse(el.textContent);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function loadMachine() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var m = JSON.parse(raw);
      return m && m.id && Array.isArray(m.values) ? m : null;
    } catch (e) {
      return null;
    }
  }

  function clearMachine() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) { /* nothing stored */ }
  }

  function saveMachine(m) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        id: m.id, make: m.make, model: m.model, values: m.values, note: m.note || ''
      }));
    } catch (e) { /* storage unavailable: nothing to remember */ }
  }

  function machineName(m) {
    return m.make + ' ' + m.model;
  }

  // Theme setting "Find dies opens the machine's own page" (snippets/die-machines.liquid).
  function machinePageUrl(m) {
    var el = document.getElementById('die-machines');
    if (!m || !m.collection || !el || el.getAttribute('data-machine-pages') !== 'true') return null;
    return (el.getAttribute('data-collections-url') || '/collections') + '/' + m.collection;
  }

  function resultsUrl(m, base) {
    var page = machinePageUrl(findById(getMachines(), m.id) || m);
    if (page) return page;
    var parts = m.values.map(function (v) {
      return encodeURIComponent(FILTER_PARAM) + '=' + encodeURIComponent(v);
    });
    parts.push('sort_by=title-ascending');
    parts.push('machine=' + encodeURIComponent(m.id));
    return (base || DEFAULT_COLLECTION) + '?' + parts.join('&');
  }

  function makesOf(machines) {
    var seen = {};
    var makes = [];
    machines.forEach(function (m) {
      if (!seen[m.make]) { seen[m.make] = true; makes.push(m.make); }
    });
    return makes.sort(function (a, b) { return a.localeCompare(b); });
  }

  function findById(machines, id) {
    for (var i = 0; i < machines.length; i++) if (machines[i].id === id) return machines[i];
    return null;
  }

  function sameValues(a, b) {
    if (a.length !== b.length) return false;
    var s = a.slice().sort();
    var t = b.slice().sort();
    return s.every(function (v, i) { return v === t[i]; });
  }

  /* ---------------- Finder (collection page) ---------------- */

  function initFinder(root) {
    var machines = getMachines();
    if (!machines.length) return;
    var base = root.dataset.collectionUrl || DEFAULT_COLLECTION;
    var makeSel = root.querySelector('[data-finder-make]');
    var modelSel = root.querySelector('[data-finder-model]');
    var submit = root.querySelector('[data-finder-submit]');
    var remembered = loadMachine();
    var params = new URLSearchParams(window.location.search);
    // Machine named by the page itself (machine collection) or by ?machine= (filtered page).
    var urlMachine = findById(machines, root.dataset.machineId || '') || findById(machines, params.get('machine') || '');
    var activeValues = (root.dataset.activeValues || '').split('|').filter(Boolean);
    var isResults = root.dataset.state === 'results';

    // Make options
    makesOf(machines).forEach(function (make) {
      var o = document.createElement('option');
      o.value = make;
      o.textContent = make;
      makeSel.appendChild(o);
    });

    function modelsOf(make) {
      return machines.filter(function (m) { return m.make === make; });
    }

    function fillModels(make, selectedId) {
      modelSel.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Select model';
      modelSel.appendChild(ph);
      if (!make) {
        modelSel.disabled = true;
      } else {
        modelsOf(make).forEach(function (m) {
          var o = document.createElement('option');
          o.value = m.id;
          o.textContent = m.model;
          if (m.id === selectedId) o.selected = true;
          modelSel.appendChild(o);
        });
        modelSel.disabled = false;
      }
      updateSubmit();
    }

    function selectedMachine() {
      return findById(machines, modelSel.value);
    }

    function updateSubmit() {
      var m = selectedMachine();
      if (m) {
        submit.href = resultsUrl(m, base);
        submit.classList.remove('is-disabled');
        submit.removeAttribute('aria-disabled');
      } else {
        submit.href = base;
        submit.classList.add('is-disabled');
        submit.setAttribute('aria-disabled', 'true');
      }
    }

    function setSelection(m) {
      makeSel.value = m ? m.make : '';
      fillModels(m ? m.make : '', m ? m.id : '');
    }

    makeSel.addEventListener('change', function () {
      fillModels(makeSel.value, '');
    });
    modelSel.addEventListener('change', updateSubmit);

    submit.addEventListener('click', function (e) {
      var m = selectedMachine();
      if (!m) {
        e.preventDefault();
        (makeSel.value ? modelSel : makeSel).focus();
        return;
      }
      saveMachine(m);
    });
    root.querySelector('[data-finder-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      submit.click();
    });

    // Remembered machine line: "Your machine: X · Change · Clear"
    var remLine = root.querySelector('[data-finder-remembered]');
    function renderRemembered() {
      if (remembered) {
        root.querySelector('[data-finder-remembered-name]').textContent = machineName(remembered);
        remLine.hidden = false;
      } else {
        remLine.hidden = true;
      }
    }
    root.querySelector('[data-finder-change]').addEventListener('click', function (e) {
      e.preventDefault();
      setSelection(null);
      makeSel.focus();
    });
    root.querySelector('[data-finder-clear]').addEventListener('click', function (e) {
      e.preventDefault();
      clearMachine();
      remembered = null;
      if (isResults) {
        window.location.href = base;
        return;
      }
      setSelection(null);
      renderRemembered();
      catalog.apply(null);
      makeSel.focus();
    });
    var catalog = initCatalog(root, machines);

    // Initial selection
    if (isResults) {
      var shown = urlMachine;
      if (!shown && remembered && sameValues(remembered.values, activeValues)) shown = findById(machines, remembered.id) || remembered;
      if (shown) {
        setSelection(shown);
        var title = root.querySelector('[data-results-title]');
        if (title) title.textContent = 'Dies for ' + machineName(shown);
        var fitText = root.querySelector('[data-results-text]');
        if (fitText) { fitText.textContent = 'Bronze pasta extruder dies designed to fit ' + machineName(shown) + ' extruders.'; fitText.hidden = false; }
        var note = root.querySelector('[data-results-note]');
        if (note && shown.note) { note.textContent = shown.note + '.'; note.hidden = false; }
        if (urlMachine) { saveMachine(urlMachine); remembered = loadMachine() || remembered; }
      }
      renderRemembered();
    } else {
      if (remembered) {
        setSelection(findById(machines, remembered.id));
      }
      renderRemembered();
      catalog.apply(remembered);
    }
  }

  /* ---------------- Catalog codes ----------------
   * Every code gets exactly one behaviour (see apply()):
   *  - machine remembered, die made for it      -> link to the product      (.is-available)
   *  - machine remembered, die not made for it  -> faded, not clickable     (.is-unavailable)
   *  - no machine, die made for >= 1 model      -> opens the machine panel  (.is-choosable)
   *  - die under no model in the index          -> opens the panel with a quote link (.is-choosable)
   */
  var CONTACT_URL = '/pages/contact';

  function initCatalog(root, machines) {
    var links = Array.prototype.slice.call(root.querySelectorAll('.die-catalog__link[data-die-code]'));
    var index = null;
    var pending = null; // machine to apply once the index has loaded
    var loaded = false;
    var panel = null;
    var openFor = null;

    function codeOf(a) { return String(a.dataset.dieCode || '').toUpperCase(); }

    /* Live check. assets/die-index.json says which product is code X for model Y, but it
       is a snapshot. A machine's die page (/collections/<machine>-dies, a collection made
       from the dies-model tag) lists only published dies, so it is read live: a die set
       to draft stops being offered and one published again comes back, without a new
       index. Dies added since the snapshot are found by their product code, the same rule
       as dev/build_die_index.py (005ILMP3 is #005, 195TTTR110 is #195TT). */
    var live = {};
    var SKU_RE = /^(\d+(?:-\d+)?[A-Z]??)(ILM|TT)(.+)$/i;
    function codeFromSku(sku) {
      var m = SKU_RE.exec(sku || '');
      if (m) return m[1].toUpperCase() + (m[2].toUpperCase() === 'TT' ? 'TT' : '');
      return /^0SFOGLIA/i.test(sku || '') ? '0SFOGLIA' : null;
    }
    function liveFor(m) {
      if (!m || !m.collection || !window.fetch) return Promise.resolve(null);
      if (!live[m.collection]) {
        var base = (document.getElementById('die-machines') && document.getElementById('die-machines').getAttribute('data-collections-url')) || '/collections';
        var handles = {}, byCode = {};
        var page = function (n) {
          return fetch(base + '/' + m.collection + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function (d) {
              var ps = (d && d.products) || [];
              ps.forEach(function (p) {
                handles[p.handle] = true;
                var sku = p.variants && p.variants[0] && p.variants[0].sku;
                var c = codeFromSku(sku);
                if (c && !byCode[c]) byCode[c] = p.handle;
              });
              return ps.length === 250 && n < 10 ? page(n + 1) : { handles: handles, byCode: byCode };
            });
        };
        live[m.collection] = page(1).catch(function () { return null; });
      }
      return live[m.collection];
    }
    // the product for code on machine m: the index's, if it is still published, else a
    // published die with that code on the machine's page; without live data, the index's
    function liveHandle(m, code, l) {
      var h = handleFor(m, code);
      if (!l) return h;
      if (h && l.handles[h]) return h;
      return l.byCode[code] || null;
    }

    function modelsWith(code) {
      return Object.keys(index).filter(function (v) { return index[v] && index[v][code]; });
    }

    /* Live machines for a shape (templates/search.die-json.liquid). The store's search
       finds dies by product code and lists published ones only. A die whose code has the
       other TT form (catalog #009, store 009TTP55) counts only when the catalog's size is
       in its title, as in dev/build_die_index.py. Added to the index's machines, never
       instead of them: a die added for a new machine is offered at once, and a die
       drafted since the snapshot still lands on its machine's page (see liveHandle). */
    var shapeLive = {};
    function norm(t) { return String(t || '').toLowerCase().replace(/\s+/g, ''); }
    function liveModels(code, size) {
      if (!window.fetch || code === '0SFOGLIA') return Promise.resolve([]);
      if (!shapeLive[code]) {
        var num = code.replace(/TT$/, '');
        var other = /TT$/.test(code) ? num : num + 'TT';
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        // one query per form, on the product code only: "a OR b", or a bare term, widens the
        // store's search to hundreds of unrelated dies (Oct 18: 006ILM* gave 247, 0 of them #006)
        var search = function (term, n) {
          return fetch(root + 'search?view=die-json&type=product&q=' + encodeURIComponent(term) + '&page=' + n,
            { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function (d) {
              var ps = (d && d.products) || [];
              return d && d.pages > n && n < 5 ? search(term, n + 1).then(function (more) { return ps.concat(more); }) : ps;
            });
        };
        shapeLive[code] = Promise.all([search('variants.sku:' + num + 'ILM*', 1), search('variants.sku:' + num + 'TT*', 1)])
          .then(function (both) {
            var found = {};
            both[0].concat(both[1]).forEach(function (p) {
              var c = codeFromSku(p.sku);
              if (c === code || (c === other && size && norm(p.title).indexOf(norm(size)) !== -1)) {
                (p.models || []).forEach(function (v) { found[v] = true; });
              }
            });
            return Object.keys(found);
          })
          .catch(function () { return []; });
      }
      return shapeLive[code];
    }

    function handleFor(m, code) {
      for (var i = 0; i < m.values.length; i++) {
        var byCode = index[m.values[i]];
        if (byCode && byCode[code]) return byCode[code];
      }
      return null;
    }

    function reset(a) {
      closePanel(false);
      a.classList.remove('is-available', 'is-unavailable', 'is-choosable');
      ['href', 'title', 'role', 'tabindex', 'aria-disabled', 'aria-haspopup', 'aria-expanded'].forEach(function (n) { a.removeAttribute(n); });
    }

    function choosable(a) {
      a.classList.add('is-choosable');
      a.setAttribute('role', 'button');
      a.setAttribute('tabindex', '0');
      a.setAttribute('aria-haspopup', 'dialog');
      a.setAttribute('aria-expanded', 'false');
    }

    function apply(machine, l) {
      if (!loaded) { pending = { machine: machine }; return; }
      var current = machine ? (findById(machines, machine.id) || machine) : null;
      if (current && l === undefined) {
        // first from the index, then again once the machine's page has been read
        liveFor(current).then(function (data) { if (data) apply(machine, data); });
        l = null;
      }
      links.forEach(function (a) {
        reset(a);
        var code = codeOf(a);
        // No product for any machine: looks like every other die; the panel offers a quote.
        if (!modelsWith(code).length && !(l && l.byCode[code])) { choosable(a); return; }
        if (current) {
          var handle = liveHandle(current, code, l);
          if (handle) {
            a.href = '/products/' + handle;
            a.classList.add('is-available');
            a.title = 'Fits your ' + machineName(current);
          } else {
            a.classList.add('is-unavailable');
            a.setAttribute('aria-disabled', 'true');
            a.title = 'Not made for your ' + machineName(current);
          }
          return;
        }
        choosable(a);
      });
    }

    /* ----- machine panel ----- */
    function buildPanel() {
      panel = document.createElement('div');
      panel.className = 'die-pick';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'false');
      panel.setAttribute('aria-labelledby', 'die-pick-title');
      panel.hidden = true;
      panel.tabIndex = -1;
      panel.innerHTML =
        '<div class="die-pick__head">' +
        '<button type="button" class="die-pick__close" aria-label="Close" data-pick-close>&times;</button>' +
        '<p class="die-pick__title" id="die-pick-title"></p>' +
        '<p class="die-pick__text"></p>' +
        '</div>' +
        '<div class="die-pick__machines"></div>';
      document.body.appendChild(panel);
      panel.querySelector('[data-pick-close]').addEventListener('click', function () { closePanel(true); });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closePanel(true); }
      });
    }

    function headerBottom() {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-end'));
      return isNaN(v) ? 0 : Math.max(0, v);
    }

    // Desktop: anchored to the code, opens toward the side with more room, and is
    // capped to the room available (and to 70% of the viewport); the machine list
    // scrolls inside it. Mobile: bottom sheet capped at 70% of the viewport.
    function position(a) {
      var vh = window.innerHeight;
      if (window.matchMedia('(max-width: 767px)').matches) {
        panel.classList.add('die-pick--sheet');
        panel.style.left = panel.style.top = '';
        panel.style.maxHeight = Math.floor(vh * 0.7) + 'px';
        return;
      }
      panel.classList.remove('die-pick--sheet');
      var GAP = 8;
      var MARGIN = 12;
      var r = a.getBoundingClientRect();
      var below = vh - r.bottom - GAP - MARGIN;
      var above = r.top - headerBottom() - GAP - MARGIN;
      var up = above > below;
      var maxH = Math.floor(Math.min(vh * 0.7, up ? above : below));
      panel.style.maxHeight = Math.max(160, maxH) + 'px';
      var width = panel.offsetWidth || 340;
      var left = Math.min(r.left + window.scrollX, window.scrollX + document.documentElement.clientWidth - width - 16);
      panel.style.left = Math.max(16, left) + 'px';
      var h = panel.offsetHeight;
      panel.style.top = (up ? r.top + window.scrollY - GAP - h : r.bottom + window.scrollY + GAP) + 'px';
      panel.classList.toggle('die-pick--up', up);
    }

    function openPanel(a) {
      if (!panel) buildPanel();
      if (openFor === a) { closePanel(true); return; }
      closePanel(false);
      var code = codeOf(a);
      var label = [a.dataset.dieGroup, a.dataset.dieSize].filter(Boolean).join(' ');
      panel.querySelector('.die-pick__title').textContent = '#' + a.dataset.dieCode + (label ? ' · ' + label : '');
      var models = modelsWith(code);
      renderFits(a, code, models);
      openFor = a;
      a.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      position(a);
      var first = panel.querySelector('.die-pick__machine') || panel;
      first.focus({ preventScroll: true });
      liveModels(code, a.dataset.dieSize).then(function (extra) {
        var added = extra.filter(function (v) { return models.indexOf(v) === -1; });
        if (!added.length || openFor !== a) return;
        var hadFocus = panel.contains(document.activeElement);
        renderFits(a, code, models.concat(added));
        position(a);
        if (hadFocus) (panel.querySelector('.die-pick__machine') || panel).focus({ preventScroll: true });
      });
    }

    function renderFits(a, code, models) {
      var fits = machines.filter(function (m) {
        return m.values.some(function (v) { return models.indexOf(v) !== -1; });
      });
      var text = panel.querySelector('.die-pick__text');
      var box = panel.querySelector('.die-pick__machines');
      box.innerHTML = '';
      if (fits.length) {
        text.textContent = 'Made for these machines. Choose yours:';
        var groups = [];
        var byMake = {};
        fits.forEach(function (m) {
          if (!byMake[m.make]) { byMake[m.make] = []; groups.push(m.make); }
          byMake[m.make].push(m);
        });
        groups.forEach(function (make) {
          var g = document.createElement('div');
          g.className = 'die-pick__group';
          var h = document.createElement('p');
          h.className = 'die-pick__make';
          h.textContent = make;
          g.appendChild(h);
          byMake[make].forEach(function (m) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'die-pick__machine';
            b.textContent = m.model;
            b.setAttribute('aria-label', machineName(m));
            b.addEventListener('click', function () {
              saveMachine(m);
              closePanel(false);
              b.disabled = true;
              liveFor(m).then(function (l) {
                var handle = liveHandle(m, code, l);
                // no longer published for this machine: its die page, rather than a dead link
                var page = machinePageUrl(m) || (m.collection ? '/collections/' + m.collection : null);
                if (handle) window.location.href = '/products/' + handle;
                else if (page) window.location.href = page;
                else apply(m);
              });
            });
            g.appendChild(b);
          });
          box.appendChild(g);
        });
      } else {
        text.innerHTML = '<a href="' + CONTACT_URL + '">Contact us</a> for a quote on this die.';
      }
    }

    function closePanel(returnFocus) {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      var a = openFor;
      openFor = null;
      if (a) {
        a.setAttribute('aria-expanded', 'false');
        if (returnFocus) a.focus({ preventScroll: true });
      }
    }

    if (!links.length) return { apply: function () {} };

    root.addEventListener('click', function (e) {
      var a = e.target.closest('.die-catalog__link');
      if (!a || a.hasAttribute('href')) return;
      // Codes without href: handle here and stop the event, because the theme's
      // document-level link handler (main.js) throws on an <a> with no href.
      e.preventDefault();
      e.stopPropagation();
      if (a.classList.contains('is-choosable')) openPanel(a);
      else closePanel(false);
    });
    root.addEventListener('keydown', function (e) {
      var a = e.target.closest && e.target.closest('.die-catalog__link.is-choosable');
      if (!a) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPanel(a); }
    });
    document.addEventListener('click', function (e) {
      if (!panel || panel.hidden) return;
      if (panel.contains(e.target) || (openFor && openFor.contains(e.target))) return;
      closePanel(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) closePanel(true);
    });
    window.addEventListener('resize', function () { if (openFor) position(openFor); });

    if (root.dataset.indexUrl && window.fetch) {
      fetch(root.dataset.indexUrl, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          index = data;
          loaded = true;
          root.setAttribute('data-catalog-ready', '');
          if (pending) apply(pending.machine);
        })
        .catch(function () { /* codes stay plain text */ });
    }
    return { apply: apply };
  }

  /* ---------------- Product page fit check ---------------- */

  function initFit(el) {
    var machines = getMachines();
    var models;
    try { models = JSON.parse(el.dataset.models || '[]'); } catch (e) { models = []; }
    if (!machines.length || !models.length) return;
    var has = {};
    models.forEach(function (v) { has[v] = true; });
    var fits = machines.filter(function (m) {
      return m.values.some(function (v) { return has[v]; });
    });
    var base = el.dataset.collectionUrl || DEFAULT_COLLECTION;

    // "Fits:" grouped by make; machines the die is made for (no note) come first.
    if (fits.length) {
      var ordered = fits.filter(function (m) { return !m.note; }).concat(fits.filter(function (m) { return m.note; }));
      var groups = [];
      var byMake = {};
      ordered.forEach(function (m) {
        if (!byMake[m.make]) { byMake[m.make] = []; groups.push(m.make); }
        byMake[m.make].push(m);
      });
      // "Make Model, Model · Make Model": each model links to its own page when
      // the machine pages are switched on.
      var list = el.querySelector('[data-fit-list]');
      list.textContent = '';
      groups.forEach(function (mk, gi) {
        if (gi) list.appendChild(document.createTextNode(' · '));
        list.appendChild(document.createTextNode(mk + ' '));
        byMake[mk].forEach(function (m, mi) {
          if (mi) list.appendChild(document.createTextNode(', '));
          var url = machinePageUrl(m);
          var node = document.createElement(url ? 'a' : 'span');
          if (url) node.href = url;
          node.textContent = m.model;
          list.appendChild(node);
        });
      });
      el.querySelector('[data-fit-list-row]').hidden = false;
    }

    var remembered = loadMachine();
    var status = el.querySelector('[data-fit-status]');
    if (remembered) {
      var current = findById(machines, remembered.id) || remembered;
      var ok = current.values.some(function (v) { return has[v]; });
      status.className = 'die-fit__status ' + (ok ? 'die-fit__status--ok' : 'die-fit__status--warn');
      status.textContent = '';
      var msg = document.createElement('span');
      msg.textContent = ok
        ? 'Fits your ' + machineName(current)
        : 'This die does not fit your ' + machineName(current);
      status.appendChild(msg);
      if (!ok) {
        var a = document.createElement('a');
        a.href = resultsUrl(current, base);
        a.textContent = 'See dies for your machine';
        status.appendChild(document.createTextNode(' '));
        status.appendChild(a);
      }
      var clear = document.createElement('a');
      clear.href = '#';
      clear.className = 'die-fit__clear';
      clear.textContent = 'Clear';
      clear.setAttribute('aria-label', 'Clear your machine');
      clear.addEventListener('click', function (e) {
        e.preventDefault();
        clearMachine();
        status.hidden = true;
        status.textContent = '';
        showChoose(true);
      });
      status.appendChild(document.createTextNode(' · '));
      status.appendChild(clear);
      status.hidden = false;
    } else {
      showChoose(false);
    }
    el.hidden = false;

    function showChoose(focus) {
      var choose = el.querySelector('[data-fit-choose]');
      if (!choose) return;
      choose.hidden = false;
      if (focus) choose.querySelector('a').focus({ preventScroll: true });
    }
  }

  function init() {
    document.querySelectorAll('[data-die-finder]').forEach(initFinder);
    document.querySelectorAll('[data-die-fit]').forEach(initFit);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
